import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { Contact, CONTACT_NAME_TYPES } from '../dynamic-contacts.model';
import { SelectItem } from 'primeng/api/selectitem';
import { ReportExportViewService } from '../../../../report-export-view.service';

@Component({
  selector: 'rep-contact-settings',
  templateUrl: './contact-settings.component.html',
  styleUrls: ['./contact-settings.component.scss'],
  standalone: false,
})
export class ContactSettingsComponent implements OnChanges {
  selectedPhone: string;
  nameCatalog = CONTACT_NAME_TYPES;
  selectedName: string;
  @Input() contactInfo: Contact[] = [];
  @Input() reportId: number;
  @Input() selectedContact: Contact;
  @Input() phoneCatalog: SelectItem[];
  @Output() refreshContacts = new EventEmitter();
  constructor(private reportExportViewService: ReportExportViewService) {}
  ngOnChanges() {
    if (this.selectedContact) {
      this.selectedPhone = this.selectedContact.phoneType ? this.selectedContact.phoneType : 'Business Phone';
      this.selectedName = this.selectedContact.nameType ? this.selectedContact.nameType.toString() : '1';
    }
  }

  phoneSelection({ value }) {
    this.selectedPhone = value;
    this.setContactSetting();
  }
  nameSelection({ value }) {
    this.selectedName = value;
    this.setContactSetting();
  }
  private setContactSetting() {
    this.selectedContact.phoneType = this.selectedPhone;
    this.selectedContact.nameType = Number(this.selectedName);
    this.reportExportViewService
      .setReportContactSetting(this.reportId, this.selectedContact)
      .subscribe(() => this.refreshContacts.emit());
  }
}
